import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-approval-workflow-form',
  templateUrl: './approval-workflow-form.component.html',
  styleUrl: './approval-workflow-form.component.scss',
  standalone: false
})
export class ApprovalWorkflowFormComponent {
  @Input() approvalData: any;

  get daysDifference(): number {
    const assignedAt = this.approvalData?.assignedAt ? new Date(this.approvalData.assignedAt) : null;
    const forwardDate = this.approvalData?.createdAt ? new Date(this.approvalData.createdAt) : null;

    if (!assignedAt || !forwardDate) { return 0; }

    const diffMs = forwardDate.getTime() - assignedAt.getTime();
    if (isNaN(diffMs) || diffMs <= 0) { return 0; }

    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
  }

}


